
/** machine.power */
export const machinePowerStatus = power => {
    return {
        title: 'POWER_'+(power == true ? 'ON' : (power == false ? 'OFF' : 'UNKNOWN')),
        bg: power == true ? 'success' : 'danger',
        icon: 'power-off'
    }
}

export const machineConnectionStatus = connection => {
    return {
        title: 'CONNECTION_'+(connection == true ? 'ON' : (connection == false ? 'OFF' : 'UNKNOWN')),
        color: connection ? 'success' : 'danger',
        icon: 'signal'
    }
}